import React, { useCallback, useImperativeHandle, useMemo, useState, forwardRef } from "react";

import { colors } from "@zapalacorp/tokens";
import Button, { Color } from "Components/Form/Button";
import { AppDrawer, AppDrawerProps } from "Components/Generic/AppDrawer";
import { EmailSubscription } from "Models/email_subscriptions";
import { useTranslation } from "react-i18next";

import { EditActivitiesSection } from "./sections";
import { EmailActivitiesSection } from "./sections/EmailActivitiesSection";
import { Cronjob } from "Models/cronjob";

export interface ManageEmailSubscriptionViewerDrawerHandles {
  open: (cronJob: Cronjob) => void;
  close: () => void;
}

export const ManageEmailSubscriptionViewerDrawer = forwardRef<
  ManageEmailSubscriptionViewerDrawerHandles,
  any
>((_props, ref) => {
  const [isOpenFleetShowDrawer, setIsOpenFleetShowDrawer] = useState<boolean>(false);
  const [cronJob, setEmailSubscription] = useState<Cronjob>();
  const { t: translate } = useTranslation();

  const title = useMemo(() => {
    if (!cronJob) return;

    return `${translate("activities")} ‘#${cronJob.id}’`;
  }, [cronJob]);

  const open = useCallback((newCronJob: Cronjob) => {
    setEmailSubscription(newCronJob);
    setIsOpenFleetShowDrawer(true);
  }, []);

  const close = useCallback(() => {
    setIsOpenFleetShowDrawer(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const sections: AppDrawerProps["sectionItems"] = [
    {
      id: "editActivities",
      title: translate("editActivities"),
      content: cronJob && <EditActivitiesSection cronJob={cronJob} />,
    },
    {
      id: "emailActivities",
      title: translate("emailActivities"),
      content: cronJob && <EmailActivitiesSection cronJob={cronJob} />,
    },
  ];

  return (
    <AppDrawer
      DrawerProps={{
        open: isOpenFleetShowDrawer,
        onClose: () => {
          setIsOpenFleetShowDrawer(false);
        },
        sx: { color: colors.gray600 },
      }}
      title={title}
      footer={
        <Button customColor={Color.BRAND_TEXT} onClick={close}>
          {translate("close")}
        </Button>
      }
      hideSideMenu
      sectionItems={sections}
    />
  );
});
